import { lazyShowInImmersiveReader } from '../index';
import type { ClientItemId } from 'owa-client-ids';
import type { ActionSource } from 'owa-analytics-types';
import type { ActionSource as SubActionSource } from 'owa-mail-store';
import { lazyReloadSecondaryTabAsDeeplink } from 'owa-tab-store';

export function onShowInImmersiveReader(
    itemId: ClientItemId,
    actionSource: ActionSource,
    subActionSource?: SubActionSource,
    targetWindow?: Window
) {
    const isProjection: boolean | undefined = targetWindow && targetWindow !== window;
    if (isProjection) {
        lazyReloadSecondaryTabAsDeeplink.importAndExecute(itemId.Id, {
            Immersive: '',
        });
    } else {
        lazyShowInImmersiveReader.importAndExecute(itemId, actionSource, subActionSource);
    }
}
